/** 首页默认内容 */

<template>
  <div>
    <div>
      <el-row style="display: flex;flex-wrap: nowrap;justify-content: center;">
        <el-col :span="24" class="indexheader">
          <div class="headerleft" @mouseleave="mouseLeave()">
            <div class="allbtn">
              <div class="item" v-for="(item, a) in typeList.slice(0, 4)" :key="item.id"
                @mouseenter="mouseEnter(a)">
                <div class="ptitle">
                  <img :src="item.pic">
                  <p @click="toDetail(a)">{{ item.cateName }}</p>
                </div>
                <div style="padding: 0 10px;max-height: 53px;overflow: hidden;">
                  <span v-for="(items,b) in item.children.slice(0, 6)" :key="items.id" @click="toDetail(a,b)">{{ items.cateName }}</span>
                </div>
                <div class="erjibtn" v-if="curIndex == a">
                  <div class="eritem" v-for="(eritems,b) in item.children" :key="eritems.id">
                    <div class="itemtitle">
                      <p @click="toDetail(a,b)">{{ eritems.cateName }}></p>
                    </div>
                    <div class="itembody">
                      <span v-for="(eritemss,c) in eritems.children" :key="eritemss.id" @click="toDetail(a,b,c)">{{ eritemss.cateName }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="headercenter">
            <el-carousel :interval="5000" arrow="always" style="height: 400px;">
              <el-carousel-item v-for="item in imgArray" :key="item">
                <img :src="item" style="width: 100%;height: 400px;">
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="headerright nologin">
            <div class="user" v-if="!status">
              <img src="@/../static/index/user-avatar-no-login.png" style="width: 60px;height: 60px;border-radius: 50%;">
              <span>欢迎光临格瑞德</span>
              <div style="width:100%;margin: 10px auto;text-align: center;">
                <el-button size="mini" @click="$router.push('/myLogin')" style="color: #F74747;">登录</el-button>
              </div>
            </div>
            <div class="user" v-else>
              <img :src="userPic" style="width: 60px;height: 60px;border-radius: 50%;">
              <span>{{ username }} 欢迎您！</span>
            </div>
            <div class="gonggao" v-if="status">
              <p>通知公告:</p>
              <div class="item">
                <template v-for="(news, index) in noticeList">
                  <a @click="lookPrice(news.id)">{{ (index + 1) + '. ' + news.title }}</a>
                  <span>{{ news.createTime[1] + '-' + news.createTime[2] }}</span>
                </template>
              </div>
            </div>
            <div class="cygn" v-if="status">
              <p>常用功能区</p>
              <div class="item" @click="$router.push('/myFindSource')">
                <i class="iconfont icon-zixun1"></i>
                <p>我的询价单</p>
              </div>
              <div class="item" @click="$router.push('/favorites')">
                <i class="iconfont icon-shoucang"></i>
                <p>我的收藏</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <FourImg/>
    <SiftItem/>
    <NewsGoodsList/>
    <Service/>
    <LiftNav/>
    <!-- 新品上市 -->
    <!-- <newGoods></newGoods>
    <goods></goods>
    <goods1></goods1>
    <goods2></goods2>
    <goods3></goods3>
    <recommend></recommend> -->
  </div>
</template>
<script>
import goods1 from "./components/good1";
import goods2 from "./components/good2";
import goods3 from "./components/good3";
import goods from "./components/goods";
import recommend from "./components/recommend.vue";
import newGoods from "./components/newGoods";
import { getCates } from "@/api/noticedetail.js";
import { mapGetters, mapMutations } from "vuex";
import { getUserInfo } from "@/api/login.js";
import eventBus from '../../../eventbus/eventbus'
import FourImg from './components/FourImg.vue'
import SiftItem from './components/SiftItem.vue'
import NewsGoodsList from './components/NewsGoodsList.vue'
import Service from '@/components/base/Service.vue'
import LiftNav from '@/components/base/LiftNav.vue'
import {
  getNoticeInfoPageList,
  noticeDel,
} from "@/api/notice.js";
export default {
  components: { newGoods, goods, goods1, goods2, goods3, recommend,FourImg,SiftItem,NewsGoodsList,Service,LiftNav },

  data() {
    return {
      userPic: "",
      status: false,
      username: "",
      showType: 0,
      noticeList: [], //公告
      circleUrl: "../../../../static/index/user.png",
      typeList: [],
      imgArray: [
        "@/../static/index/banner_111.jpg"
      ],
      curIndex: -1,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getTypeList();
    let userEntity = JSON.parse(sessionStorage.getItem('SET_USER_INFO'));
    if (userEntity) {
      this.status = true;
      this.getUserInfo();
    }
    eventBus.$on('userInfoEvent', (st) => {
      if (st === 1) {
        this.getUserInfo()
      }
    })
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      this.loading = true;
      try {
        let res = await getUserInfo();
        if (res.status === 200) {
          this.status = true;
          this.userPic = res.data.avatar;
          this.username = res.data.nickname;
          this.getNoticeInfo()
        }
      } catch (error) {
        this.status = false;
        this.userPic = '';
        this.username = '';
        sessionStorage.removeItem('SET_USER_INFO')
      }

    },
    // 跳转到商品
    toDetail(a, b, c) {
      console.log(11199);
      this.$router.push({
        path: "/indexpage/productlist",
        query: {
          a: a,
          b: b,
          c: c,
        },
      });
    },
    // 公告
    getNoticeInfo() {
      getNoticeInfoPageList({ page: 1, limit: 3 }).then(res => {
        res.data.forEach(item => {
          item.createTime = item.createTime.split(' ')[0].split('-')
        });
        this.noticeList = res.data
      });
    },
    //查看公告
    lookPrice(id) {
      const routerJump = this.$router.resolve({
        path: '/noticeDetail',
        query: { id: id }
      })
      window.open(routerJump.href, '_blank')
    },
    clickItem(item) {
      this.curIndex = -1;
    },
    async getTypeList() {
      var res = await getCates();
      this.typeList = res.data;
      console.log(this.typeList);
    },
    routLinkTo(val) {
      if (val === '/quickly') {
        this.$router.push(val)
        //   const { href } = this.$router.resolve({
        //   path: "/quickly",

        // });
        // window.open(href, "_blank");
      } else {
        this.$router.push(val)
      }
    },
    //三级菜单弹出
    mouseEnter(index) {
      this.curIndex = index;
    },
    //三级菜单隐藏
    mouseLeave() {
      this.curIndex = -1;
    },
    mouseEnter1() {
      this.showType = 1
      console.log('999', this.showType);
    },
    mouseLeave1() {
      this.showType = 0
      console.log('999', this.showType);

    },
  },
};
</script>

<style lang="less" scoped>
.indexheader {
  width: 1440px;
  height: 400px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  margin: 10px 0;

  .headerleft {
    position: relative;
    width: 20%;
    padding: 5px;
    background-color: #fff;

    .allbtn {
      width: 100%;

      .item {
        width: 100%;
        padding: 5px;
        cursor: pointer;
        margin: 14px 0px;

        .ptitle {
          display: flex;
          flex-wrap: nowrap;
          justify-content: center;
          align-items: center;

          img {
            width: 14px;
            height: 14px;
            margin: 0 5px 0 0;
            vertical-align: middle;
          }

        }

        &:hover {
          background-color: #efefef;
        }

        p {
          width: 100%;
          font-size: 15px;
          font-weight: 900;
          text-align: left;
          color: #333;
        }

        span {
          display: inline-block;
          padding: 5px 10px;
          font-size: 14px;
          color: #666;

          &:hover {
            color: #F74747;
          }
        }
      }
    }

    .erjibtn {
      box-sizing: border-box;
      position: absolute;
      left: 100%;
      top: 0;
      overflow: scroll;
      overflow-x: hidden;
      width: 700px;
      height: 100%;
      padding: 5px 20px;
      background-color: #fff;
      border-left: 1px solid #efefef;
      z-index: 999;

      .eritem {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        cursor: pointer;
        line-height: 30px;
        padding: 10px;
        border-bottom: 1px solid #efefef;

        .itemtitle {
          width: 20%;

          p {
            text-align: right;
            width: 100%;
            font-size: 15px;
            font-weight: 400;
          }
        }

        .itembody {
          width: 80%;
          color: #666;
          padding-left: 10px;

          span {
            display: inline-block;
            font-size: 14px;
            padding: 0 10px;

            &:hover {
              color: #F74747;
            }
          }
        }
      }
    }
  }

  .headercenter {
    width: 60%;
    margin: 0 15px;

    .el-carousel__item {
      height: 400px;
    }

    /deep/.el-carousel__container {
      height: 400px !important;
    }
  }

  .headerright {
    width: 20%;
    padding: 20px;
    background-color: #fff;

    .nologin {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    .user {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin: 5px 0 0;
      padding: 0 0 5px;
      border-bottom: 1px dashed #efefef;

      span {
        margin: 0 20px;
      }

      .el-button:focus,
      .el-button:hover {
        color: #F74747;
        background-color: #fff;
        border-color: #F74747;
      }
    }

    .gonggao {
      width: 100%;
      height: auto;
      border-bottom: 1px solid #efefef;

      p {
        padding: 20px 0 10px;
      }

      .item {
        width: 100%;

        a {
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          margin: 10px 0;
          font-size: 14px;
          width: 80%;

          &:hover {
            color: #F74747;
          }
        }

        span {
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          margin: 10px 0;
          font-size: 14px;
        }
      }
    }

    .cygn {
      width: 100%;
      font-size: 15px;

      p {
        text-align: left;
        font-size: 15px;
        margin: 20px 0 10px;
      }

      .item {
        float: left;
        width: 50%;
        text-align: center;
        cursor: pointer;
        margin: 10px 0 0;

        i {
          font-size: 30px;
          color: #333;
        }

        p {
          color: #333;
          width: 100%;
          text-align: center;
          margin: 5px 0;
        }

        &:hover {
          i {
            color: #F74747;
          }

          p {
            color: #F74747;
          }
        }
      }
    }
  }
}

.erjibtn::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}

.erjibtn::-webkit-scrollbar-thumb {
  background-color: #F74747;
  border-radius: 10px;
}

.erjibtn::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/Index.vue